#import "../fragments/email-automation-status.graphql"

query GetEmailAutomationsQueued($limit: Int!, $cursor: String) {
    emailAutomationStatusesQueued(first: $limit, after: $cursor) {
        pageInfo {
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...EmailAutomationStatus
            }
        }
    }
}
